<div class="sum">
    <div class="sum__head">
        <h3 class="sum__title">Your items</h3>
        <vb-chip [tone]="chipTone">{{ chipLabel }}</vb-chip>
    </div>

    <div class="sum__items">
        <div class="sum__item" *ngFor="let item of invoiceDetails?.items">
            <span class="sum__item-text">
                <span class="sum__item-name">{{ item.name }}</span>
                <span class="sum__item-qty">Qty {{ item.quantity }}</span>
            </span>
            <span class="sum__item-price">
                ${{ item.price | number: '1.2-2' }}
            </span>
        </div>
    </div>

    <div class="sum__totals">
        <div class="sum__row">
            <span class="sum__label">Subtotal</span>
            <span class="sum__value">
                ${{ invoiceDetails?.invoice?.itemsSubtotal | number: '1.2-2' }}
            </span>
        </div>
        <div class="sum__row">
            <span class="sum__label">Buyer's premium</span>
            <span class="sum__value">
                ${{
                    invoiceDetails?.invoice?.buyerPremiumTotal
                        | number: '1.2-2'
                }}
            </span>
        </div>
        <div class="sum__row" *ngIf="showShippingTbd">
            <span class="sum__label">Shipping</span>
            <span class="sum__value">TBD</span>
        </div>
        <div class="sum__row">
            <span class="sum__label">Tax</span>
            <span class="sum__value">
                ${{ invoiceDetails?.invoice?.taxesSubtotal | number: '1.2-2' }}
            </span>
        </div>
    </div>

    <div class="sum__grand">
        <div class="sum__row sum__row--grand">
            <span class="sum__grand-label">Total</span>
            <span class="sum__display">
                ${{ invoiceDetails?.invoice?.totalAmount | number: '1.2-2' }}
            </span>
        </div>
        <div class="sum__row">
            <span
                class="sum__label"
                [class.sum__label--paid]="amountPaid > 0">
                Amount paid
            </span>
            <span
                class="sum__value"
                [class.sum__value--paid]="amountPaid > 0">
                ${{ amountPaid | number: '1.2-2' }}
            </span>
        </div>
        <div class="sum__row sum__row--grand">
            <span class="sum__grand-label">Amount due</span>
            <span
                class="sum__display"
                [class.sum__display--due]="amountDue > 0">
                ${{ amountDue | number: '1.2-2' }}
            </span>
        </div>
    </div>

    <!-- Desktop in-rail confirm; the page's sticky bar replaces it on mobile. -->
    <div class="sum__confirm" *ngIf="!paymentSuccess">
        <vb-button
            variant="primary"
            [fullWidth]="true"
            [disabled]="!confirmEnabled"
            [loading]="isLoading"
            (clicked)="confirmPayment()">
            {{ confirmLabel }}
        </vb-button>
        <p class="sum__hint" *ngIf="!confirmEnabled">
            Complete the steps to confirm your order.
        </p>
    </div>
</div>
